export default __webpack_public_path__ + "static/media/Tailwind_CSS_Logopng.ad29f4bf.png";